var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "23px",
    viewBox: "0 0 17 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google_Maps_icon_(2020)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toxicology",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toxicological-appointment-confirmation",
    transform: "translate(-779.000000, -705.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-1",
    transform: "translate(735.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_Maps_icon_(2020)",
    transform: "translate(44.000000, 458.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4349698,0.381344411 C9.67228097,0.138670695 8.8402568,0 7.99089879,0 C5.54682779,0 3.34543051,1.10936556 1.87205438,2.86008308 L5.65083082,6.03217523 L10.4349698,0.381344411 Z",
    id: "Path",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87205438,2.86008308 C0.710687311,4.24679003 0,6.04950906 0,7.99089879 C0,9.4989426 0.294675227,10.7123112 0.797356495,11.8043429 L5.65083082,6.03217523 L1.87205438,2.86008308 Z",
    id: "Path",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00823263,4.9401435 C9.70694864,4.9401435 11.0763218,6.30951662 11.0763218,8.00823263 C11.0763218,8.75358761 10.7989804,9.44694109 10.3483006,9.98429003 C10.3483006,9.98429003 12.7577039,7.10687311 15.1151057,4.31612538 C14.1444109,2.444071 12.4630287,1.02269637 10.4349698,0.381344411 L5.65083082,6.03217523 C6.22284743,5.37348943 7.0548716,4.9401435 8.00823263,4.9401435",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00823263,11.0589879 C6.30951662,11.0589879 4.9401435,9.6896148 4.9401435,7.99089879 C4.9401435,7.24554381 5.20015106,6.55219033 5.65083082,6.03217523 L0.797356495,11.8043429 C1.62938066,13.6417296 3.01608761,15.1324396 4.43746224,16.9871601 L10.3483006,9.96695619 C9.77628399,10.6429758 8.94425982,11.0589879 8.00823263,11.0589879",
    id: "Path",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2442976,18.9285498 C12.9137085,14.7510952 16.0164653,12.8617069 16.0164653,8.00823263 C16.0164653,6.67352719 15.6871224,5.42549094 15.1151057,4.31612538 L4.43746224,16.9871601 C4.88814199,17.5765106 5.35615559,18.2525302 5.80683535,18.9458837 C7.43621601,21.45929 6.98553625,22.95 8.02556647,22.95 C9.06559668,22.95 8.61491692,21.4419562 10.2442976,18.9285498",
    id: "Path",
    fill: "#34A853"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsIcon);
export default __webpack_public_path__ + "static/media/google_maps_icon.0cdff8d33b3ededd9a588b6d6e1e83e7.svg";
export { ForwardRef as ReactComponent };